/**
 * Lightweight Paraglide-compatible runtime для `@staiter/i18n`.
 * Compile-step не требуется: JSON-файлы загружаются напрямую, тип-сейфные
 * функции генерируются `src/messages.ts`.
 *
 * AsyncLocalStorage-scoped locale используется в Node (server-runtime.ts).
 * Browser mutation — через `setLanguageTag`.
 */
import { FALLBACK_CHAIN } from '@staiter/shared';
import enMessages from '../messages/en.json' with { type: 'json' };
import kkMessages from '../messages/kk.json' with { type: 'json' };
import ruMessages from '../messages/ru.json' with { type: 'json' };
import zhMessages from '../messages/zh.json' with { type: 'json' };
const CATALOGS = {
    ru: ruMessages,
    en: enMessages,
    kk: kkMessages,
    zh: zhMessages,
};
export const availableLanguageTags = ['ru', 'en', 'kk', 'zh'];
export const sourceLanguageTag = 'ru';
let currentTag = 'ru';
let getLanguageTagResolver = () => currentTag;
let missingKeyHandler = () => { };
export function setLanguageTag(tag) {
    currentTag = tag;
}
export function getLanguageTag() {
    return getLanguageTagResolver();
}
/** server-runtime.ts подставляет AsyncLocalStorage-aware resolver. */
export function setLanguageTagResolver(fn) {
    getLanguageTagResolver = fn;
}
export function setMissingKeyHandler(fn) {
    missingKeyHandler = fn;
}
/**
 * Lookup ключа с fallback chain.
 * Возвращает шаблон-строку, либо в dev — маркер `[missing: key]` для catching.
 */
export function lookup(key, localeOverride) {
    const locale = localeOverride ?? getLanguageTagResolver();
    const primary = CATALOGS[locale]?.[key];
    if (typeof primary === 'string')
        return primary;
    for (const fb of FALLBACK_CHAIN[locale] ?? []) {
        const v = CATALOGS[fb]?.[key];
        if (typeof v === 'string') {
            missingKeyHandler(locale, key);
            return v;
        }
    }
    missingKeyHandler(locale, key);
    return `[missing: ${key}]`;
}
/** ICU-like interpolation: заменяет `{param}` на `params.param`. */
export function interpolate(template, params) {
    if (!params)
        return template;
    return template.replace(/\{(\w+)\}/g, (_, name) => {
        const v = params[name];
        return v === undefined || v === null ? '' : String(v);
    });
}
/** Короткий хелпер — используется в сгенерированных функциях messages.ts. */
export function t(key, params, localeOverride) {
    return interpolate(lookup(key, localeOverride), params);
}
//# sourceMappingURL=runtime.js.map